import qs from 'qs';
import request from '@/config/request';

/*
  购买记录列表分页
  productName,userPhone，shopName，beginTime，endTime
*/
export function getBuyRecordList({ page, pageSize, ...rest }) {
  return request({
    url: `/buy/getBuyRecordList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  消费记录列表分页
  productName,userPhone，shopName，beginTime，endTime
*/
export function getBuyRecordDetailList({ page, pageSize, ...rest }) {
  return request({
    url: `/buy/getBuyRecordDetailList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  购买记录导出
  productName,userPhone，shopName，beginTime，endTime
*/
export function exportBuyRecord(rest) {
  return request({
    url: '/buy/exportBuyRecord',
    method: 'get',
    params: rest,
    responseType: 'blob',
  });
}

/*
  消费记录导出
  productName,userPhone，shopName，beginTime，endTime
*/
export function exportBuyRecordDetail(rest) {
  return request({
    url: '/buy/exportBuyRecordDetail',
    method: 'get',
    params: rest,
    responseType: 'blob',
  });
}

/*
  购买门店宝列表
  shopName
*/
export function getAppShopList(rest) {
  return request({
    url: '/buy/getAppShopList',
    method: 'post',
    data: qs.stringify(rest),
  });
}
